import React from 'react';
import styled from "@emotion/styled";
import { Inner, gridColumns } from 'styles/structure';
import colors from "styles/colors";
import dimensions from 'styles/dimensions';
import Content from 'components/_ui/Content';
import Button from 'components/_ui/Button';

const GettingStartedContainer = styled.div`
  background-color: ${colors.orange200};
  padding: 5.6rem 0 7.2rem;
  margin-top: 6.4rem;
  
  & + * {
    margin-top: 6.4rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    padding: 12rem 0 10.4rem;
  }
`;

const GettingStartedHeader = styled.div`
  margin-bottom: 6.4rem;
  padding-bottom: 1.6rem;
  border-bottom: 1px solid ${colors.grey400};
  
  h2 {
    & + * {
      margin-top: 1.2rem;
    }
  }
  
  p {
    max-width: 72.8rem;
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    text-align: left;
    margin-bottom: 9.6rem;
    
    > h2, 
    > p {
      flex: 1 1 50%;
    }
    
    h2 {
      margin-right: 5.6vw;
      
      & + * {
        margin-top: 0;
      }
    }
    
    p {
      padding-right: 7.2rem;
    }
  }
`;

const GettingStartedList = styled.ul`
  counter-reset: gettingStartedCounter;
  
  li {
    position: relative;
    counter-increment: gettingStartedCounter;  
    z-index: 1;
    min-height: 32.4rem;
    
    &::before {
      content: counter(gettingStartedCounter);
      display: block;
      position: absolute;
      top: 0;
      left: 50%;
      transform: translateX(-50%);
      color:  #fff;
      font-size: 35.6rem;
      font-weight: 500;
      line-height: 1;
    }
    
    
    & + * {
      margin-top: 6.4rem;
    }
  }
  
  div {
    position: relative;
    padding: 10.4rem 0 4rem;
    z-index: 10;
  }
  
  h5 {
    font-size: 2.4rem;
    
    & + * {
      margin-top: 2.4rem;
    }
  }
  
  p {
    color: ${colors.teal700};
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    
    li {
      ${gridColumns('1/3', 3.2)}
      
      padding: 0 2.4rem;
      
      & + * {
        margin-top: 0;
      }
      
      div {
        position: relative;
        padding: 8rem 0 4.8rem;
        z-index: 10;
      }
    }
  }
`;

const GettingStartedButtons = styled.div`
  width: 100%;
  margin-top: 5.6rem;
  
  > * {
    width: 100%;
    
    & + * {
      margin-top: 2.4rem;
    }
  }
  
  @media(min-width: ${dimensions.tabletPortraitUp}px) {
    > * {
      width: auto;
    }
  }
  
  @media(min-width: ${dimensions.tabletLandscapeUp}px) {
    display: flex;
    justify-content: center;
    
    > * {
      & + * {
        margin-top: 0;
        margin-left: 2rem;
      }
    }
  }
`;

const GettingStarted = ({ content, items, buttonText, buttonDestination }) => {
  return (
    <GettingStartedContainer id='getting-started'>
      <Inner>
        {content && (
          <GettingStartedHeader>
            <h2>Get Started</h2>
            <Content content={content}/>
          </GettingStartedHeader>
        )}

        <GettingStartedList>
            {items.map((item, i) => (
              <li key={i}>
                <div>
                  {item.heading && <h5>{item.heading}</h5>}
                  {item.text && <p>{item.text}</p>}
                </div>
              </li>
            ))}
        </GettingStartedList>

        {(buttonText && buttonDestination) && (
          <GettingStartedButtons>
            <Button
              as='a'
              href={buttonDestination}
            >
              <span>{buttonText}</span>
            </Button>
          </GettingStartedButtons>
        )}
      </Inner>
    </GettingStartedContainer>
  );
};

export default GettingStarted;
